export default "__VITE_ASSET__B_2_48EO__"